export default [
  {
    path: '/pedidos',
    name: 'app-client-pedido-list',
    component: () => import('@/views/apps/pedido/pedido-list/List.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Pedidos',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Lista de Pedidos',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pedidos/:id',
    name: 'app-client-pedido-edit',
    component: () => import('@/views/apps/pedido/pedido-edit/Edit.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Pedidos',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Pedidos',
          active: true,
        },
        {
          text: 'Lista de Pedidos',
          active: false,
          to: {
            name: 'app-client-pedido-list',
          },
        },
        {
          text: 'Editar Pedido',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pedidos/add',
    name: 'app-client-pedido-add',
    component: () => import('@/views/apps/pedido/pedido-add/Add.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Pedidos',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Pedidos',
          active: true,
        },
        {
          text: 'Lista de Pedidos',
          active: false,
          to: {
            name: 'app-client-pedido-list',
          },
        },
        {
          text: 'Adicionar Pedido',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pedidos/visualizar/:id',
    name: 'app-client-pedido-preview',
    component: () => import('@/views/apps/pedido/pedido-preview/Preview.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Pedidos',
      action: 'read',
      resource: 'Vendedor',
      breadcrumb: [
        {
          text: 'Lista de Pedidos',
          active: false,
          to: {
            name: 'app-client-pedido-list',
          },
        },
        {
          text: 'Visualizar Pedido',
          active: true,
        },
      ],
    },
  },
]
